<template>
  <section class="hero">
    <div class="container">
      <div data-aos="fade-left" data-aos-duration="3000" class="bg-video">
        <video class="bg-video_content" autoplay muted loop>
          <source :src="bgVideo" type="video/mp4" />
          Your browser is not supported!
        </video>
      </div>
      <div class="contacts">
        <div class="routes">
          <router-link to="/" style="text-decoration: none"
            ><img src="../assets/media/english.png" />
          </router-link>
          <router-link to="/ja" style="text-decoration: none"
            ><img src="../assets/media/japanese.png" />
          </router-link>
        </div>
        <div class="image-box">
          <img src="../assets/media/tree.png" />
        </div>
        <div data-aos="fade-down" data-aos-duration="1500" class="wrap">
          <div class="contact" v-for="(link, index) in links" :key="index">
            <a :href="link.url" target="_blank"><img :src="link.icon" /></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroComponent",
  data() {
    return {
      bgVideo: require("../assets/media/video.mp4"),
      links: [
        {
          name: "GitHub",
          url: "https://github.com/IzumiKeiki",
          icon: require("../assets/media/github.png"),
        },
        {
          name: "LinkedIn",
          url: "https://www.linkedin.com/in/keiki-izumi-006364254/",
          icon: require("../assets/media/linkedin.png"),
        },
        {
          name: "Email",
          url: "mailto:_@hotmail.com",
          icon: require("../assets/media/outlook.png"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: linear-gradient(to top, #fff 25%, #1f0d14 70%);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;

  .bg-video {
    align-self: center;
    height: 100%;
    width: 100%;
    padding: 3rem 0 3rem 1.5rem;

    &_content {
      height: 100%;
      width: 100%;
    }
  }

  .contacts {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-direction: column;
    padding: 0 1rem;
    background-color: #2f9e44;

    .routes {
      display: flex;
      align-items: center;

      img {
        margin: 1rem 1rem 0 0;
        width: 2.5rem;
        filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
        transition: all 0.5s ease;

        &:hover {
          transform: translateY(-15%);
          scale: 1.05;
        }

        &:active {
          transform: translateY(-10%);
          scale: 0.9;
        }
      }
    }

    .image-box {
      padding: 1.5rem;
      position: relative;
      overflow: hidden;
      width: 20rem;

      img {
        object-fit: contain;
        width: 100%;
        animation: appear 2.5s linear;
      }
    }

    .wrap {
      display: flex;
      align-items: flex-end;
    }

    .contact {
      margin: 1rem;

      img {
        width: 3rem;
        filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
        transition: all 0.5s ease;

        &:hover {
          transform: translateY(-20%);
          scale: 1.2;
        }
      }
    }
  }
}

@keyframes appear {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0);
  }
}

@media screen and (max-width: 1000px) {
  .container {
    .contacts {
      .image-box {
        padding: 3rem 1rem 1rem;
        width: 15rem;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .container {
    flex-direction: column;

    .bg-video {
      padding: 1.5rem;
    }

    .contacts {
      background-image: none;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;

      .contact {
        margin-top: 0;
        padding: 1rem 0 0;
      }

      .image-box {
        display: none;
      }
    }
  }
}
</style>
